import { render, staticRenderFns } from "./MyAccessTokensPage.vue?vue&type=template&id=350c54fa"
import script from "./MyAccessTokensPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyAccessTokensPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports